// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-console */
import React from "react";
import bugsnag from "@bugsnag/js";
import bugsnagReact from "@bugsnag/plugin-react";

const isError = e => e && e.stack && e.message;

class ApplicationMonitoring {
  constructor() {
    if (process.env.NODE_ENV === "production") {
      const bugsnagAccount = bugsnag({
        apiKey: process.env.REACT_APP_BUGSNAG_KEY,
        appVersion: process.env.REACT_APP_BUILD_HASH,
        appType: "account"
      });
      bugsnagAccount.use(bugsnagReact, React);
      this.bugsnag = bugsnagAccount;
    } else {
      // use mock bugsnag locally
      this.bugsnag = {
        notify: console.log,
        getPlugin: () => React.Fragment,
        user: {}
      };
    }
  }

  captureError(error) {
    let errorToReport = error;
    if (!isError(errorToReport)) {
      errorToReport = new Error(error);
    }
    this.bugsnag.notify(errorToReport);
  }

  setUserContext({ id, name, email }) {
    this.bugsnag.user = {
      id,
      name,
      email
    };
  }

  getErrorBoundaryComponent() {
    return this.bugsnag.getPlugin("react");
  }
}

export default new ApplicationMonitoring();
